import { Link } from "react-router-dom";
import { FileText, HandCoins, ClipboardCheck, ArrowRight } from "lucide-react";
import { scrollToId } from "@/lib/api";

const POINTS = [
  { icon: HandCoins, t: "Príspevok na obnovu", d: "Zateplenie fasády patrí medzi opatrenia podporované z programu Obnov dom. Pomôžeme vám zorientovať sa v podmienkach." },
  { icon: ClipboardCheck, t: "Technické parametre", d: "Navrhneme skladbu a hrúbku zateplenia tak, aby spĺňala požiadavky na energetickú úsporu." },
  { icon: FileText, t: "Podklady k žiadosti", d: "Pripravíme cenovú ponuku a technické podklady, ktoré potrebujete k dokumentácii žiadosti." },
];

export default function ObnovDom() {
  return (
    <section id="obnov-dom" className="bg-ink py-20 md:py-28 border-t border-white/10" data-testid="obnov-dom">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <p className="font-mono2 text-gold uppercase tracking-[0.3em] text-xs mb-5">Štátna podpora</p>
            <h2 className="font-display text-4xl md:text-6xl leading-[0.95] text-white">
              Využite dotáciu <span className="text-gold">Obnov dom</span>
            </h2>
            <p className="text-white/60 leading-relaxed text-base md:text-lg mt-6 max-w-xl">
              Program Obnov dom podporuje komplexnú obnovu rodinných domov vrátane zateplenia obvodového
              plášťa. Zateplenie fasády je jedným z kľúčových opatrení, ktoré pomáha znížiť spotrebu energie.
              Radi vám poradíme a pripravíme podklady k vašej žiadosti.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => scrollToId("#kalkulacka")}
                data-testid="obnov-dom-cta"
                className="group bg-gold text-ink px-8 py-4 font-bold uppercase tracking-wider flex items-center justify-center gap-3 hover:bg-gold-light transition-colors"
              >
                Vypočítať cenu zateplenia <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </button>
              <Link
                to="/dotacia-na-zateplenie/bratislava"
                data-testid="obnov-dom-more"
                className="border border-white/25 text-white px-8 py-4 font-bold uppercase tracking-wider flex items-center justify-center gap-2 hover:border-gold hover:text-gold transition-colors"
              >
                Viac o dotácii
              </Link>
            </div>
            <p className="text-white/35 text-xs mt-5 max-w-xl leading-relaxed">
              Podmienky, výška príspevku a termíny výziev sa riadia aktuálnymi pravidlami programu.
              Nie sme štátna inštitúcia — poskytujeme realizáciu zateplenia a podklady k žiadosti.
            </p>
          </div>

          <div className="space-y-4">
            {POINTS.map((p) => (
              <div key={p.t} className="border border-white/10 bg-ink-2 p-6 flex gap-5" data-testid={`obnov-point-${p.t[0]}`}>
                <p.icon className="w-8 h-8 text-gold shrink-0" />
                <div>
                  <div className="text-white font-semibold mb-1">{p.t}</div>
                  <p className="text-white/55 text-sm leading-relaxed">{p.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
